export enum enumBinaCatalogItemElementType {
  LEFT_COLUMN,
  MIDDLE_COLUMN,
  MIDDLE_COLUMN_HEADER,
  MIDDLE_COLUMN_BODY,
  MIDDLE_COLUMN_FOOTER,
  RIGHT_COLUMN,
  TITLE_EDIT_ICON,
  BASED_ON_YOUR_SEARCH,
  INSERT_TO_LINE_ITEM,
}
